<template>
    <div class="upload-wrapper" ref="imgContainer">
        <!--顯示時, 使用-->
        <code v-if="show_upload_btn == false">
            <ul class="el-upload-list el-upload-list--picture-card">
                <li class="el-upload-list__item is-success" style="width:100px" v-for="file in fileList" :key="file.id">
                    <div style="width: 100px; height:100px;">
                        <img class="el-upload-list__item-thumbnail image-size" :src="file.url" @click.stop="handlePictureCardPreview(file)">
                    </div>
                    <span class="el-upload-list__item-actions" @click.stop="handlePictureCardPreview(file)">
                        <span class="el-upload-list__item-preview">
                            <i class="el-icon-zoom-in"></i>
                        </span>
                    </span>
                    <span class="small2">{{ file.uploader }}</span>
                </li>
            </ul>
        </code>
        <!--編輯時, 使用-->
        <!--class="upload-demo" disabled="true" :before-upload="beforeAvatarUpload"-->
        <el-upload disabled="disabled" v-if="show_upload_btn == true" :auto-upload="true" :on-preview="handlePreview"
            :before-remove="before_remove" :on-remove="handleRemove" :file-list="fileList"
            :before-upload="before_upload" :on-success="onSuccess" :on-error="onError" :action="urlpre"
            list-type="picture-card">
            <div slot="file" slot-scope="{file}"
                style="height:138px; display: flex; justify-content: center; align-items: center;">
                <div style="width:100px; float: left;">
                    <div style="width: 100px; height:100px;">
                        <img class="el-upload-list__item-thumbnail image-size" :src="file.url" alt=""
                            @click.stop="handlePictureCardPreview(file)" v-if="file.url.length > 0">
                        <div v-else style="cursor: pointer;" class="el-upload-list__item-thumbnail image-size">
                            <div style="width: 100%;" @click="Upload_pic" v-if="IsMobile() != null">
                                <i class="el-icon-upload" style="font-size: 48px;"></i>
                                <div style="font-size: 14px;">{{ lab_1 }}</div>
                                <div style="font-size: 14px;">{{ lab_2 }}</div>
                            </div>
                            <div style="width: 100%; display: flex; align-items: center; flex-direction:column;"
                                @paste="PasteUpload" v-else @dragover.prevent="handleDragOver"
                                @drop.prevent="handleDrop" class="drop-zone">
                                <i class="el-icon-document-copy" style="font-size: 48px;"></i>
                                <div style="font-size: 14px;">&nbsp;</div>
                                <div style="font-size: 14px;">{{ lab_4 }}</div>
                            </div>
                        </div>
                    </div>
                    <span class="el-upload-list__item-actions" style="width:100px;"
                        @click.stop="handlePictureCardPreview(file)" v-if="file.url.length > 0">
                        <span class="el-upload-list__item-preview">
                            <i class="el-icon-zoom-in"></i>
                        </span>
                    </span>
                    <span class="small2" v-if="file.url.length > 0">{{ file.uploader }}</span>
                    <!-- <span class="small2" v-else><input style="width: 100%;" placeholder="在此粘貼圖片"
                            @paste="PasteUpload"></span> -->
                </div>
                <div style="float: right; width:20px; height:100%; text-align: center; color: orange;"
                    v-if="file.url.length > 0">
                    <span @click="handle_remove(file)">
                        <i class="el-icon-delete"></i>
                    </span>
                </div>
            </div>
            <div slot="default" @click="Upload_pic"
                v-if="IsMobile() == null && (is_single_iamge == false || GetFileList.length == 0)" class="uploadDiv_Pc">
                <i class="el-icon-plus" style="width: 60px;"></i>
            </div>
            <div slot="tip" class="el-upload__tip" style="display:inline;font-size: 16px;"
                v-if="IsMobile() == null && (is_single_iamge == false || GetFileList.length == 0)">
                {{ lab_3 }}
            </div>
        </el-upload>
        <form style="display: none;" ref="hideForm">
            <input type="file" ref="hideFiles" accept="image/jpeg,image/png" multiple @change="SelectedFiles" />
        </form>
        <el-dialog :visible.sync="dialogVisible" width="90%" append-to-body>
            <div slot="title" v-if="IsMobile() == null">
                <div style="width:100%; display: flex;">
                    <div :class="sizeSet == '窗口' ? 'panelSelected3' : 'pannel'" @click="chgSize('窗口')">窗口大小</div>
                    <div style="width:50px;"></div>
                    <div :class="sizeSet == '原圖' ? 'panelSelected3' : 'pannel'" @click="chgSize('原圖')">原圖大小</div>
                </div>
            </div>
            <div class="PicNavi" style="left: 0;" v-show="showPrevNav()">
                <div class="PicArrow" @click="showPrevPic"><i class="el-icon-arrow-left"></i></div>
            </div>
            <div v-if="sizeSet == '窗口'" style="width: 100%; display: flex; justify-content: center;">
                <img :style="'max-width: 100%; max-height: ' + dialogHeight" :src="dialogImageUrl" alt="">
            </div>
            <img v-else style="width: 100%;" :src="dialogImageUrl" alt="">
            <div class="PicNavi" style="right: 0;" v-show="showNextNav()">
                <div class="PicArrow" @click="showNextPic"><i class="el-icon-arrow-right"></i></div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { Get_wx_photo, Save_photo } from "@/api/rms86/Get_wx_sign_upload";
import { IsMobile } from "@/script/common";
import { previewImages } from 'hevue-img-preview/v2'
export default {
    //接收外部傳入數據
    props: {
        showID: "",
        controlID: "",
        copyFromID: "", //Job新增、編輯使用模板時，從模板複製圖片
        mergeFromID: "",
        hideUploadBtn: true,
        is_single_iamge: { default: false }, //是否只上传单张照片

        compressBeforeUpload: { default: true }, //是否压缩图片，只有餐牌識別時設置為false
        lab_1: { default: "點擊上傳" },
        lab_2: { default: "jpg/png文件" },
        lab_3: { default: "只能上傳jpg/png文件" },
        lab_4: { default: "點一下，Ctrl+V" },
    },
    data() {
        return {
            searchData_name_value: "",
            file_path: "",
            fileList: [],
            show_upload_btn: true,
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            appid: "",
            timestamp: "",
            nonceStr: "",
            signature: "",
            wx_url: "",
            wx_media_id: "",
            loadingPic: false,

            checkCount: 100,   //檢查次數
            checkTimer: null,   //檢查定時器

            sizeSet: "窗口",
            popImgStyle: "width: 100%px;",
        };
    },
    methods: {
        handleRemove(file, fileList) {
            this.fileList = fileList;
        },
        handle_remove(file) {
            // 实现缩略图模板时删除文件
            let index = this.fileList.findIndex(fileItem => {
                return fileItem.uid === file.uid
            });
            this.fileList.splice(index, 1);
        },
        handlePictureCardPreview(file) {
            if (this.IsMobile() != null) {
                let curl = file.url;
                let arr_res = [];
                let fIndex = 0;
                for (let i = 0; i < this.fileList.length; i++) {
                    let url = this.fileList[i].url;
                    if (url == curl) fIndex = i;
                    let indexExt = url.lastIndexOf(".");
                    if (indexExt != -1) {
                        url = url.substr(0, indexExt) + "_o" + url.substr(indexExt);
                        arr_res.push(url);
                    }
                }

                previewImages({
                    nowImgIndex: fIndex,
                    imgList: arr_res,
                    thumbnail: false, // 是否显示缩略图
                    disableTransition: false,//关闭过渡动画
                    controlBar: ['zoomOut', 'zoomIn', 'reset', 'prev', 'next'],
                });
            }
            else {
                let url = file.url;
                let indexExt = url.lastIndexOf(".");
                if (indexExt != -1) {
                    url = url.substr(0, indexExt) + "_o" + url.substr(indexExt);
                }
                this.dialogImageUrl = url;
                this.sizeSet = "窗口";
                this.dialogVisible = true;
            }
        },
        before_remove(file, fileList) {
            return this.show_upload_btn;
        },
        handlePreview(file) {

        },
        before_upload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 1;
            if (!isJPG) {
                this.$message.error('圖片格式只支持 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('單張圖不能超過1M!');
            }
            if (isJPG && isLt2M) {
                this.$emit('disSubmit');
            }
            return isJPG && isLt2M;
        },
        // 保存圖
        onSuccess(response, file, fileList) {
            if (response.isSuccess) {
                this.fileList.push({ id: null, name: response.newFileName, url: response.url });
            }
            this.$emit('enSubmit');
        },
        onError(err, file, fileList) {
            var index = 0;
            for (var i in fileList) {
                if (fileList[i] == file) {
                    index = i;
                    break;
                }
            }
            fileList.splice(index, 1);

            this.$emit('enSubmit');
        },
        //讀取圖
        async GetPhoto() {
            if (this.loadingPic) {
                return;
            }

            this.loadingPic = true;

            this.fileList = [];
            if ((this.copyFromID || "") != "") {
                var data = await Get_wx_photo({
                    params: {
                        capture_id: this.copyFromID,
                    },
                });
                this.fileList = data.data;
            }
            else if ((this.showID || "") != "") {
                var data = await Get_wx_photo({
                    params: {
                        capture_id: this.showID,
                    },
                });
                this.fileList = data.data;
            }
            //合并圖片
            if ((this.mergeFromID || "") != "") {
                var data = await Get_wx_photo({
                    params: {
                        capture_id: this.mergeFromID,
                    },
                });
                this.fileList.push(...data.data);
            }

            if (this.fileList.length > 0) {
                this.$nextTick(() => { this.loadingImgs(); });
            }
            else {
                this.$emit('ImagesLoaded');
            }

            if (this.show_upload_btn == true && (this.is_single_iamge == false || this.fileList.length == 0)) {
                this.fileList.push({ id: null, name: "", url: "", uploader: "" });
            }

            this.loadingPic = false;
        },
        Upload_pic() {
            this.$refs.hideFiles.click();
        },
        checkFile(file) {
            var res = "";
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJPG) {
                res = file.name + '不是 JPG/PNG 格式!\n';
            }
            return res;
        },
        async uploadFileItem(fileItem, cpy_fileList, index) {
            let _msg = "";
            var fchk = this.checkFile(fileItem);
            if (fchk.length > 0) {
                _msg += fchk;
            }
            else {
                const formData = new FormData();
                formData.append("fileIndex", index);

                if (this.compressBeforeUpload == true) {
                    var compressedFile = await this.compressImage(fileItem, 0);
                    if (compressedFile.size / 1024 > 512) {
                        compressedFile = await this.compressImage(fileItem, 1);
                    }
                    if (compressedFile.size / 1024 > 512) {
                        _msg += fileItem.name + "超過500Kb\n";
                    }
                    else {
                        formData.append("file", compressedFile);
                        var res_up = await Save_photo(formData);
                        if (res_up.isSuccess == true) {
                            var cname = this.Get_sys_user_name();
                            //只有餐牌識別保存原文件名
                            let _name = this.compressBeforeUpload == true ? res_up.newFileName : fileItem.name;
                            cpy_fileList.push({ id: null, name: _name, url: res_up.url, uploader: cname });
                        }
                        else {
                            _msg += fileItem.name + "上傳失敗\n";
                        }
                    }
                }
                else {
                    formData.append("file", fileItem);
                    var res_up = await Save_photo(formData);
                    if (res_up.isSuccess == true) {
                        var cname = this.Get_sys_user_name();
                        //只有餐牌識別保存原文件名
                        let _name = this.compressBeforeUpload == true ? res_up.newFileName : fileItem.name;
                        cpy_fileList.push({ id: null, name: _name, url: res_up.url, uploader: cname });
                    }
                    else {
                        _msg += fileItem.name + "上傳失敗\n";
                    }
                }
            }
            return _msg;
        },
        async SelectedFiles(e) {
            if (this.is_single_iamge && this.GetFileList.length > 0) {
                this.$message.error("主照片只能上传一张");
                return false;
            }
            if (this.$refs.hideFiles.files.length == 0)
                return;

            this.showloading();
            var cpy_fileList = JSON.parse(JSON.stringify(this.GetFileList));
            var _msg = "";
            for (let index = 0; index < this.$refs.hideFiles.files.length; index++) {
                let fileItem = this.$refs.hideFiles.files[index];
                let msg = await this.uploadFileItem(fileItem, cpy_fileList, index);
                if (msg.length > 0) _msg += msg;
            }
            if (this.show_upload_btn == true && (this.is_single_iamge == false || this.fileList.length == 0)) {
                cpy_fileList.push({ id: null, name: "", url: "", uploader: "" });
            }
            this.fileList = cpy_fileList;
            this.hideloading();
            if (_msg.length > 0) this.$message.error(_msg);

            this.$nextTick(() => {
                //試圖清空input type=file
                var obj = this.$refs.hideForm;
                obj.reset();
            });
        },
        //粘貼圖片并上傳
        async PasteUpload(event) {
            event.preventDefault();
            let clipboardData = event.clipboardData;
            if (clipboardData) {
                let items = clipboardData.items;
                if (items && items.length > 0) {
                    if (items[0].kind !== 'file') return;

                    let file = items[0].getAsFile();
                    this.showloading();
                    let cpy_fileList = JSON.parse(JSON.stringify(this.GetFileList));
                    let msg = await this.uploadFileItem(file, cpy_fileList, 0);

                    if (this.show_upload_btn == true && (this.is_single_iamge == false || this.fileList.length == 0)) {
                        cpy_fileList.push({ id: null, name: "", url: "", uploader: "" });
                    }
                    this.fileList = cpy_fileList;
                    this.hideloading();
                    if (msg.length > 0) this.$message.error(msg);

                }
            }
        },
        //拖到圖片文件上傳
        handleDragOver(event) {
            event.dataTransfer.dropEffect = 'copy'; // 设置拖放效果为复制
            this.$el.querySelector('.drop-zone').classList.add('over'); // 添加样式表示可以放置
        },
        async handleDrop(event) {
            const files = event.dataTransfer.files; // 获取文件列表
            if (files.length) {
                this.showloading();
                var cpy_fileList = JSON.parse(JSON.stringify(this.GetFileList));
                var _msg = "";
                for (let index = 0; index < files.length; index++) {
                    let fileItem = files[index];
                    let msg = await this.uploadFileItem(fileItem, cpy_fileList, index);
                    if (msg.length > 0) _msg += msg;
                }
                if (this.show_upload_btn == true && (this.is_single_iamge == false || this.fileList.length == 0)) {
                    cpy_fileList.push({ id: null, name: "", url: "", uploader: "" });
                }
                this.fileList = cpy_fileList;
                this.hideloading();
                if (_msg.length > 0) this.$message.error(_msg);
            }
            this.$el.querySelector('.drop-zone').classList.remove('over'); // 移除样式表示放置结束
        },

        /* 全部圖片加載完成 */
        loadingImgs() {
            this.checkCount = 100;
            let that = this;
            this.checkTimer = setInterval(function () {
                var allComplete = true;
                var pc = that.$refs.imgContainer;
                if (pc != null) {
                    var imgs = pc.querySelectorAll("img");
                    imgs.forEach(img => {
                        if (!img.complete) {
                            allComplete = false;
                        }
                    });
                }
                if (allComplete) {
                    clearInterval(that.checkTimer);
                    that.$emit('ImagesLoaded');
                    return;
                }

                that.checkCount--;
                if (that.checkCount <= 0) {
                    clearInterval(that.checkTimer);
                    that.checkCount = 100;
                    that.$emit('ImagesFailure');
                    return;
                }
            }, 20);
        },
        /* 全部圖片加載完成 */

        /**
        * @压缩公共方法
        * @params file
        * @return 压缩后的文件，支持两种，file和 blob
        */
        compressImage(file, iSize) {
            var setWidth = 1280;
            var setHeight = 1024;
            if (iSize == 1) {
                setWidth = 800;
                setHeight = 600;
            }
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                // readAsDataURL 方法会读取指定的 Blob 或 File 对象。读取操作完成的时候，readyState 会变成已完成DONE，并触发 loadend (en-US) 事件，
                // 同时 result 属性将包含一个data:URL格式的字符串（base64编码）以表示所读取文件的内容。
                reader.readAsDataURL(file);
                reader.onload = () => {
                    const img = new Image();
                    img.src = reader.result;
                    img.onload = () => {
                        // 图片的宽高
                        var w = img.width;
                        var h = img.height;
                        var canvas = document.createElement("canvas");
                        // canvas对图片进行裁剪
                        if (w > setWidth || h > setHeight) {
                            if (w > h) {
                                h = h * setWidth / w;
                                w = setWidth;
                            }
                            else {
                                w = w * setHeight / h;
                                h = setHeight;
                            }
                        }
                        canvas.width = w;
                        canvas.height = h;
                        const ctx = canvas.getContext("2d");
                        // canvas中，png转jpg会变黑底，所以先给canvas铺一张白底
                        ctx.fillStyle = "#fff";
                        // fillRect()方法绘制一个填充了内容的矩形，这个矩形的开始点（左上点）在
                        // (x, y) ，它的宽度和高度分别由width 和 height 确定，填充样式由当前的fillStyle 决定。
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                        // 绘制图像
                        ctx.drawImage(img, 0, 0, w, h);

                        /*
                        // canvas转图片达到图片压缩效果
                        // 返回一个包含图片展示的 data URI base64 在指定图片格式为 image/jpeg 或 image/webp的情况下，
                        // 可以从 0 到 1 的区间内选择图片的质量。如果超出取值范围，将会使用默认值 0.92。其他参数会被忽略。
                        const dataUrl = canvas.toDataURL("image/jpeg", 0.8);
                        // base64格式文件转成Blob文件格式
                        let blobFile = this.dataURLtoBlob(dataUrl);
                        // base64格式文件转成file文件格式
                        let fileImg = this.dataURLtoFile(dataUrl, file.name);
                        */

                        canvas.toBlob(blob => {
                            resolve(new File([blob], file.name, { type: 'image/jpeg' }));
                            canvas = null;
                        }, 'image/jpeg', 0.8);
                    };

                };
                reader.onerror = error => reject(error);
            });
        },

        // canvas生成的格式为base64，需要进行转化, base64->file
        dataURLtoFile(dataurl, fileName) {
            let arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],

                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], fileName, { type: mime })
        },
        // canvas生成的格式为base64，需要进行转化, base64->blob
        dataURLtoBlob(dataurl) {
            const arr = dataurl.split(","),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        },

        //指定彈出圖片顯示大小
        chgSize(setting) {
            this.sizeSet = setting;
        },

        //圖片導航
        showPrevNav() {
            if (this.fileList < 2) return false;
            var url = this.fileList[0].url;
            var indexExt = url.lastIndexOf(".");
            if (indexExt != -1) {
                url = url.substr(0, indexExt) + "_o" + url.substr(indexExt);
            }
            return url != this.dialogImageUrl;
        },
        showNextNav() {
            if (this.fileList < 2) return false;
            var url = this.fileList[this.fileList.length - 1].url;
            var indexExt = url.lastIndexOf(".");
            if (indexExt != -1) {
                url = url.substr(0, indexExt) + "_o" + url.substr(indexExt);
            }
            return url != this.dialogImageUrl;
        },
        showPrevPic() {
            var posi = 0;
            for (var i = 0; i < this.fileList.length; i++) {
                var url = this.fileList[i].url;
                var indexExt = url.lastIndexOf(".");
                if (indexExt != -1) {
                    url = url.substr(0, indexExt) + "_o" + url.substr(indexExt);
                }
                if (url == this.dialogImageUrl) {
                    posi = i;
                    break;
                }
            }
            if (posi > 0) {
                var url = this.fileList[posi - 1].url;
                var indexExt = url.lastIndexOf(".");
                if (indexExt != -1) {
                    url = url.substr(0, indexExt) + "_o" + url.substr(indexExt);
                }
                this.dialogImageUrl = url;
            }
        },
        showNextPic() {
            var posi = 0;
            for (var i = 0; i < this.fileList.length; i++) {
                var url = this.fileList[i].url;
                var indexExt = url.lastIndexOf(".");
                if (indexExt != -1) {
                    url = url.substr(0, indexExt) + "_o" + url.substr(indexExt);
                }
                if (url == this.dialogImageUrl) {
                    posi = i;
                    break;
                }
            }
            if (posi < this.fileList.length - 1) {
                var url = this.fileList[posi + 1].url;
                var indexExt = url.lastIndexOf(".");
                if (indexExt != -1) {
                    url = url.substr(0, indexExt) + "_o" + url.substr(indexExt);
                }
                this.dialogImageUrl = url;
            }
        },

        //清空以前選擇圖片
        clearFiles() {
            this.fileList = [];
            if (this.show_upload_btn == true && (this.is_single_iamge == false || this.fileList.length == 0)) {
                this.fileList.push({ id: null, name: "", url: "", uploader: "" });
            }
        },
    },
    created() {
        //vue 定義為全局方法， js 就可以調用方法了
        this.show_upload_btn = !this.hideUploadBtn;
    },
    async mounted() {
        this.SetFontSize(this.$store.getters.size);
        try {
            // const s = document.createElement('script');
            // s.type = 'text/javascript';
            // //https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/iOS_WKWebview.html
            // s.src = 'https://res.wx.qq.com/open/js/jweixin-1.2.0.js';
            // //s.src = '/src/script/jweixin-1.2.0.js';
            // document.body.appendChild(s);
            await this.loadScript('https://res.wx.qq.com/open/js/jweixin-1.2.0.js');
        }
        catch (error) { }
        //讀取要顯示的圖片
        //setTimeout(() => {}, 1500);
        await this.GetPhoto();
    },
    watch: {
        //編輯現有記錄時，會異步加載數據，綁定的showID也會在加載時改變
        showID: {
            async handler(val) {
                await this.GetPhoto();
            }
        },
        copyFromID: {
            async handler(val) {
                await this.GetPhoto();
            }
        },
        hideUploadBtn: {
            handler(val) {
                this.show_upload_btn = !val;
                if (val) {
                    this.fileList = this.GetFileList;
                }
                else {
                    this.fileList = this.GetFileList;
                    this.fileList.push({ id: null, name: "", url: "", uploader: "" });
                }
            }
        }
    },
    computed: {
        GetFileList() {
            return this.fileList.filter(t => t.url.length > 0);
        },
        urlpre() {
            var pro = window.location.origin + "/api";
            pro += "/FileUpload/FormSingleFileUpload";
            return pro;
        },
        dialogHeight() {
            var iHeight = parseInt(this.$store.getters.current_height);
            return iHeight + "px";
        },
    },
};
</script>
<style>
/*改變預覽圖片大小*/
.upload-wrapper .el-upload-list__item-thumbnail {
    max-width: 100px;
    max-height: 100px;
    width: auto;
    height: auto;
    position: relative;
}

/*改變框大小*/
.upload-wrapper .el-upload-list__item {
    width: 120px;
    height: 140px;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
}

/*改變選擇圖片框大小*/
.upload-wrapper .el-upload--picture-card {
    width: 60px;
    height: 20px;
    display: inline;
    justify-content: center;
    align-items: center;
}

/*改變選擇圖片框中的圖標+的大小 font-size: 180px !important;*/
.upload-wrapper .el-upload--picture-card i {
    font-size: 20px !important;
}

.el-upload--picture-card {
    line-height: 20px;
    border: none;
}

/*删除图标如何一直显示在右上角*/
.upload-wrapper .el-icon-delete {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
    cursor: pointer;
}

.el-upload-list--picture-card {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}

.pannel {
    cursor: pointer;
    border: 1px solid rgb(60, 141, 188);
}

.panelSelected3 {
    cursor: pointer;
    background-color: rgb(60, 141, 188);
    color: white !important;
}

.uploadDiv_Mobile {
    display: flex;
    height: 60px;
    align-items: center;
    border: 1px solid #cccccc;
}

.uploadDiv_Pc {
    display: inline;
    border: 1px dashed #c0ccda;
}

.PicNavi {
    position: absolute;
    top: 50px;
    height: 100%;
    z-index: 999;
    display: flex;
    align-items: center;
}

.PicArrow {
    font-size: 40px;
    color: red;
    background-color: #333;
    opacity: 0.7;
}

.el-image-viewer__canvas {
    overflow: auto;
    justify-content: left;
}

.el-image-viewer__canvas img {
    transform-origin: top left;
}
</style>
<style scoped>
.drop-zone {}

.drop-zone.over {
    border-color: #333;
}
</style>